export default {
    /** 圆角 */
    radius: false
}
